export const FIND_LANGUAGES_REQUEST = 'FIND_LANGUAGES_REQUEST';

export const findLanguagesRequest = () => ({
    type: FIND_LANGUAGES_REQUEST,
});
